import { Axios } from 'src/class/Axios.js';
import { isset, ifExistNumber } from 'src/util/Util.js';
import i18n from 'src/i18n';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default function captureMethods() {
  return {
    // ==========================
    // 🔹 MANEJADORES DE EVENTOS
    // ==========================

    /** Maneja el cambio de año y actualiza la lista de semanas. */
    onYearChange(year) {
      if (isset(year)) {
        this.weekList = this.generateWeekList(year);
      }
      this.showForm = false;
    },

    /** Maneja cambios en los filtros y actualiza datos del formulario. */
    onFilterChange(data) {
      this.$set(this.form, data.name, data.selects);
      if (data.name == 'farm_id') {
        const selectedFarm = this.farms.find(
          (farm) => farm.id === data.selects
        );

        this.farmSelected = selectedFarm.name;
        this.getFarmLots(selectedFarm.id);
      }
      this.showForm = false;
    },

    /** Maneja cambios en los inputs dinámicos del formulario. */
    onInputChange(data) {
      try {
        switch (data.name) {
          case 'activity':
            if (Array.isArray(this.form.activity)) {
              this.$set(this.form.activity, data.index, data.selects);
            }

            break;
          case 'lot':
            if (Array.isArray(this.form.lot)) {
              this.$set(this.form.lot, data.index, data.selects);
            }

            break;
          default:
            this.$set(this, data.name, data.selects);

            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    /** Alterna la visibilidad del modal. */
    toggleModal() {
      this.showModal = !this.showModal;
    },

    /** Maneja la selección de semanas mediante checkboxes. */
    onWeekSelectionChange(index, week) {
      const weekIndex = this.form.weeks[index].indexOf(week);

      if (weekIndex === -1) {
        this.form.weeks[index].push(week);
        if (this.showModal) {
          SweetAlert.input(
            i18n.t('labor.enter_periodicity'),
            null,
            i18n.t('common_words.accept'),
            {
              type: 'number',
              placeholder: '',
            }
          )
            .then((result) => {
              if (!result.dismiss) {
                if (
                  result.value &&
                  !isNaN(result.value) &&
                  result.value > 0 &&
                  result.value < this.weekList.length
                ) {
                  const step = parseInt(result.value, 10);
                  const currentWeekIndex = this.weekList.indexOf(week);

                  for (
                    let i = currentWeekIndex + step;
                    i < this.weekList.length;
                    i += step
                  ) {
                    if (!this.form.weeks[index].includes(this.weekList[i])) {
                      this.form.weeks[index].push(this.weekList[i]);
                    }
                  }
                } else {
                  SweetAlert.warning(
                    i18n.t('common_words.must_enter_valid_number')
                  );
                }
              }
            })
            .catch((error) => {
              console.error('Error con el checkbox:', error);
            });
        }
      } else {
        this.form.weeks[index].splice(weekIndex, 1);
      }
    },

    /**
     * Método para el checkbox de área específico, se active o no
     * debo limpiar el campo de lote y el área designada si el
     * área es específica
     * */
    onCustomSelectionChange(index) {
      this.$set(this.form.custom, index, !this.form.custom[index]);
      this.$set(this.form.lot, index, null);
      this.$set(this.form.covered_area, index, null);
    },

    /** Limpia la selección de semanas de una fila específica. */
    clearWeekSelection(index) {
      this.$set(this.form.weeks, index, []);
    },

    /** Agrega una nueva fila en el formulario. */
    addScheduleRow() {
      this.form.nCatchs++;
      this.form.activity.push(null);
      this.form.lot.push([]);
      this.form.custom.push(false);
      this.form.covered_area.push(null);
      this.$set(this.form.weeks, this.form.nCatchs - 1, []);
    },

    /** Verifica si una semana está deshabilitada. */
    isPastWeekDisabled(week) {
      const currentWeek = moment().format('YYYYWW');

      return week < currentWeek;
    },

    /** Elimina una fila del formulario. */
    handleDelete(index) {
      if (this.form.nCatchs > 1) {
        this.form.nCatchs--;
        const fieldsToRemove = [
          'activity',
          'lot',
          'weeks',
          'custom',
          'covered_area',
        ];

        fieldsToRemove.forEach((field) => {
          this.removeArrayItem(this.form, field, index);
        });
      }
    },

    // ==========================
    // 🔹 FUNCIONES AUXILIARES
    // ==========================

    /** Elimina un elemento de un array dentro del formulario. */
    removeArrayItem(form, field, index) {
      try {
        if (!Array.isArray(form[field])) {
          console.warn(
            `El campo ${field} no es un array válido en el formulario.`
          );
          return;
        }
        const updatedField = form[field].filter((_, i) => i !== index);
        this.$set(form, field, updatedField);
      } catch (error) {
        console.error(`Error al actualizar ${field}: `, error);
      }
    },

    /** Obtiene la lista de semanas para un año dado. */
    generateWeekList(selectedYear) {
      const year = selectedYear || moment().year();
      const weekList = [];

      const weeksInYear = moment(
        `${year}-12-31`,
        'YYYY-MM-DD'
      ).isoWeeksInYear();

      for (let week = 1; week <= weeksInYear; week++) {
        const formattedWeek = `${year}${week < 10 ? '0' : ''}${week}`;
        weekList.push(formattedWeek);
      }

      return weekList;
    },

    /** Obtiene la lista de lotes de una finca */
    getFarmLots(farmId) {
      const farm = this.farms.find((item) => item.id === farmId);

      if (farm && farm.lots) {
        this.farmLots = farm.lots;
        this.farmLotsMultiple = this.concatAll(farm.lots);
      } else {
        this.farmLots = [];
        this.farmLotsMultiple = [];
      }
    },

    /**
     * Obtiene nombre de lote y actividad dado un entry de full/specific allocation
     * @param {{ lotId: any, activity: any }} entry
     * @returns {{ lotName: string, activityName: string }}
     */
    getConflictInfo(entry) {
      const lotObj = this.farmLots.find((l) => l.id === entry.lotId);
      const activityObj = this.activities.find((a) => a.id === entry.activity);

      return {
        lotName: lotObj ? lotObj.name : '',
        activityName: activityObj ? activityObj.name : '',
      };
    },

    // ==========================
    // 🔹 VALIDACIONES
    // ==========================

    /** Valida los datos ingresados en el formulario. */
    async isFormValid() {
      const valid = await this.$validator.validateAll({
        activity: this.form.activity,
        lot: this.form.lot,
      });

      if (!valid) return false;

      for (let i = 0; i < this.form.nCatchs; i++) {
        if (!isset(this.form.activity[i])) {
          this.validationInputsRequired('activity');

          return false;
        }

        if (!isset(this.form.lot[i])) {
          if (isset(this.form.custom[i])) {
            this.validationInputsRequired(`lot_${i}`);
          } else {
            this.validationInputsRequired(`lot_${i}`, false, false, true);
          }

          return false;
        }

        if (
          isset(this.form.custom[i]) &&
          (!ifExistNumber(this.form.covered_area[i]) ||
            this.form.covered_area[i] < 0)
        ) {
          SweetAlert.warning(
            `${i18n.t('labor.specific_area_selected_notice')} ${i + 1}`
          );

          return false;
        }

        if (!isset(this.form.weeks[i])) {
          SweetAlert.warning(
            `${i18n.t('labor.select_at_least_one_week')} ${i + 1}`
          );

          return false;
        }

        if (!this.validateLotAreas()) {
          return false;
        }
      }

      return true;
    },

    /**
     * Verifica conflictos “100% del área” (fullAllocations) contra fullAllocations
     * y specificAllocations, solo si comparten la misma actividad.
     * Retorna false y muestra alerta si hay choque; true si no hay conflictos.
     *
     * @param {Array<{ row: number, lotId: any, week: string, activity: any }>} fullAllocations
     * @param {Array<{ row: number, lotId: any, week: string, activity: any, area?: number }>} specificAllocations
     * @returns {boolean}
     */
    checkFullAllocationConflicts(fullAllocations, specificAllocations) {
      for (let idx = 0; idx < fullAllocations.length; idx++) {
        const current = fullAllocations[idx];
        const { row: rowIndex, lotId, week, activity } = current;

        // 3a) Conflicto full vs full: mismo lote+semana+actividad
        const fullConflict = fullAllocations.find(
          (e, j) =>
            j !== idx &&
            e.lotId === lotId &&
            e.week === week &&
            e.activity === activity
        );
        if (fullConflict) {
          const { lotName, activityName } = this.getConflictInfo(current);
          SweetAlert.warning(
            this.$t('labor.repeated_schedule', {
              lot: lotName,
              week,
              activity: activityName,
              firstRow: rowIndex + 1,
              secondRow: fullConflict.row + 1,
            })
          );

          return false;
        }

        // 3b) Conflicto full vs specific: mismo lote+semana+actividad
        const specificConflict = specificAllocations.find(
          (e) => e.lotId === lotId && e.week === week && e.activity === activity
        );
        if (specificConflict) {
          const { lotName, activityName } = this.getConflictInfo(current);
          SweetAlert.warning(
            this.$t('labor.repeated_schedule', {
              lot: lotName,
              week,
              activity: activityName,
              firstRow: rowIndex + 1,
              secondRow: specificConflict.row + 1,
            })
          );

          return false;
        }
      }

      return true;
    },

    /**
     * Valida conflictos de uso de lotes por semana:
     * - Si custom[i] === true: agrupa sumas de covered_area por (lote, semana, actividad) y
     *   verifica que no excedan el área máxima de ese lote.
     * - Si custom[i] === false: ningún otro registro (custom true o false) puede
     *   usar ese mismo lote en esa misma semana+actividad.
     * Retorna true si no hay conflictos; en caso contrario, muestra SweetAlert
     * con el índice de fila conflictiva y retorna false.
     */
    validateLotAreas() {
      const getLotMaximumArea = (lotId) => {
        const lotObject = this.farmLots.find((l) => l.id === lotId);

        return lotObject ? Number(lotObject.area) : 0;
      };

      /**
       * 2) Generar dos listas planas:
       *  - specificAllocations: filas con custom=true → { row, lotId, week, area, activity }
       *  - fullAllocations:     filas con custom=false → { row, lotId, week, activity }
       */
      const specificAllocations = [];
      const fullAllocations = [];

      for (let i = 0; i < this.form.nCatchs; i++) {
        const isCustomRow = Boolean(this.form.custom[i]);
        const lotValue = this.form.lot[i];
        const selectedWeeks = this.form.weeks[i];
        const activityId = this.form.activity[i];

        if (isCustomRow) {
          const areaValue = Number(this.form.covered_area[i]);
          for (const week of selectedWeeks) {
            specificAllocations.push({
              row: i,
              lotId: lotValue,
              week,
              area: areaValue,
              activity: activityId,
            });
          }
        } else {
          for (const lotId of lotValue) {
            for (const week of selectedWeeks) {
              fullAllocations.push({
                row: i,
                lotId,
                week,
                activity: activityId,
              });
            }
          }
        }
      }

      /**
       * 3) Verificar conflictos “100% del área” (fullAllocations)
       *
       *    Reglas (solo misma actividad):
       *    a) Dos filas fullAllocations no pueden compartir lote+semana+actividad.
       *    b) Una fila fullAllocations no puede compartir lote+semana+actividad con specificAllocations.
       */
      if (
        !this.checkFullAllocationConflicts(fullAllocations, specificAllocations)
      ) {
        return false;
      }

      /**
       * 4) Verificar conflictos “área específica” (specificAllocations)
       *
       *    Reglas:
       *    • Agrupar por clave "lotId|week|activity" y sumar áreas.
       *    • Si la suma excede el área máxima del lote, alerta y retorna false.
       *
       * Nota: válida aquí porque v-validate no cubre esta suma compuesta.
       */
      const groupedAllocations = {};
      for (const entry of specificAllocations) {
        const { row: rowIndex, lotId, week, area, activity } = entry;
        const key = `${lotId}|${week}|${activity}`;

        if (!groupedAllocations[key]) {
          groupedAllocations[key] = { totalArea: 0, rows: [] };
        }
        groupedAllocations[key].totalArea += area;
        groupedAllocations[key].rows.push(rowIndex);

        const maxArea = getLotMaximumArea(lotId);
        if (groupedAllocations[key].totalArea > maxArea) {
          const { lotName, activityName } = this.getConflictInfo(entry);

          SweetAlert.warning(
            this.$t('labor.area_exceeded', {
              sumArea: groupedAllocations[key].totalArea,
              lot: lotName,
              maxArea,
              week,
              activity: activityName,
            })
          );

          return false;
        }
      }

      // Si llegamos aquí, no hay conflictos y pasa la validación
      return true;
    },

    /** Valida los filtros seleccionados en el formulario. */
    validateSelectedFilters() {
      this.$validator
        .validateAll({
          farm_id: this.form.farm_id,
          year_sel: this.form.year_sel,
        })
        .then(() => {
          if (!isset(this.form.farm_id)) {
            return this.validationInputsRequired('farm');
          } else if (!isset(this.form.year_sel)) {
            return this.validationInputsRequired('year');
          } else {
            this.showHideLoading(true);
            const data = {
              ...this.form,
              route: 'works/cpa/index',
            };

            Axios.postMasters(data)
              .then((response) => {
                if (isset(response.data.data)) {
                  this.form.id = response.data.data.id;
                  this.form.activity = response.data.data.activity;
                  this.form.lot = response.data.data.lot;
                  this.form.custom = response.data.data.custom;
                  this.form.covered_area = response.data.data.covered_area;
                  this.form.weeks = response.data.data.weeks;
                  this.form.nCatchs = response.data.data.nCatchs;
                } else {
                  this.form.id = null;
                  this.resetForm();
                }

                this.showForm = true;
                this.showHideLoading();
              })
              .catch((error) => {
                console.error('Error al indexar:', error);
                this.showHideLoading();
              });
          }
        });
    },

    /**
     * Valida si el input para las áreas especificas debe estar habilitado o deshabilitado
     * teniendo en cuenta que el input tiene su v-validate y necesito cual es el lote
     * seleccionado para el limite de valor de Ha.
     * */
    isCoveredAreaDisabled(index) {
      try {
        if (
          this.form &&
          Array.isArray(this.form.custom) &&
          Array.isArray(this.form.lot)
        ) {
          return !this.form.custom[index] || !this.form.lot[index];
        } else {
          console.error(
            'Inconsistencia en datos para el método [isCoveredAreaDisabled]'
          );

          return false;
        }
      } catch (err) {
        console.error('[isCoveredAreaDisabled] excepción:', err);

        return false;
      }
    },

    // ==========================
    // 🔹 OPERACIONES CRUD
    // ==========================

    /** Guarda el cronograma validando los datos previamente. */
    async saveSchedule() {
      const isValid = await this.isFormValid();

      if (isValid) {
        this.saveOrUpdateSchedule();
      }
    },

    /** Crea o actualiza un cronograma en la base de datos. */
    async saveOrUpdateSchedule() {
      try {
        this.showHideLoading(true);
        const endpoint = this.form.id ? Axios.updateMaster : Axios.postMasters;
        const data = { ...this.form, route: 'works/cpa' };
        const response = await endpoint(data);
        this.showHideLoading();
        this.form.id = response.data.data.id;
        SweetAlert.success(response.data.message);
      } catch (error) {
        this.showHideLoading();
        SweetAlert.warning(error);
      }
    },

    /** Elimina un cronograma existente. */
    removeSchedule() {
      if (this.form.id) {
        try {
          this.showHideLoading(true);
          let data = {
            id: this.form.id,
            route: `works/cpa`,
          };
          Axios.destroyMaster(data)
            .then((response) => {
              this.showHideLoading();
              this.form.id = null;
              this.resetForm();
              SweetAlert.success(response.data.message);
            })
            .catch((error) => SweetAlert.warning(error));
        } catch (error) {
          console.error('Error al eliminar:', error);
        }
      } else {
        this.resetForm();
      }
    },

    /** Limpia el formulario. */
    resetForm() {
      this.form.activity = [];
      this.form.lot = [];
      this.form.weeks = [[]];
      this.form.custom = [false];
      this.form.covered_area = [null];
      this.form.nCatchs = 1;
    },
  };
}
